module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Copyright")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Diversion Books"), _c('br'), _vm._v("\n  A Division of Diversion Publishing Corp."), _c('br'), _vm._v("\n  443 Park Avenue South, Suite 1008"), _c('br'), _vm._v("\n  New York, NY 10016"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.DiversionBooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.DiversionBooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Copyright © 1975 by Herman Raucher"), _c('br'), _vm._v("\n  All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("This is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("For more information, email "), _c('a', {
    attrs: {
      "href": "mailto:info@diversionbooks.com"
    }
  }, [_vm._v("info@diversionbooks.com")]), _c('br'), _vm._v("\n  For more from Herman Raucher, visit "), _c('a', {
    attrs: {
      "href": "http://www.hermanraucher.com",
      "target": "_blank"
    }
  }, [_vm._v("www.hermanraucher.com")])]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("First Diversion Books edition May 2015"), _c('br'), _vm._v("\n  ISBN: 978-1-62681-808-8")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "sigil_not_in_toc"
  }, [_vm._v("Also by Herman Raucher")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/morefrom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maynard’s House"), _c('br'), _vm._v("\n  Summer of ’42"), _c('br'), _vm._v("\n  There Should Have Been Castles")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("for M. K., who is always there")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a89184e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/03i_copy.vue
// module id = 63
// module chunks = 0